export const buildDetectionOptions = (pathname: string = '') => {
    const normalizedPathname = pathname.toLowerCase();
    const isPhonebookRoute = normalizedPathname === '/phonebook/view-more' || normalizedPathname.startsWith('/phonebook/view-more/');

    return {
        order: isPhonebookRoute
            ? ['cookie', 'navigator', 'localStorage', 'subdomain', 'queryString', 'htmlTag']
            : ['path', 'cookie', 'navigator', 'localStorage', 'subdomain', 'queryString', 'htmlTag'],
        lookupFromPathIndex: 0
    };
};
